import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogoZoomIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogoZoom",
    children: /*#__PURE__*/_jsx("path", {
      d: "M31.6 10.975C30.73 5.56 26.44 1.27 21.024.4a31.7 31.7 0 0 0-10.049 0C5.56 1.27 1.27 5.56.4 10.975a31.7 31.7 0 0 0 0 10.05C1.27 26.44 5.56 30.73 10.976 31.6a31.7 31.7 0 0 0 10.048 0c5.416-.87 9.706-5.16 10.576-10.576a31.7 31.7 0 0 0 0-10.049M5.686 20.888c-.556 0-1.052-.331-1.265-.845s-.096-1.098.297-1.491l5.485-5.485H6.272a1.955 1.955 0 0 1-1.955-1.955h7.302c.556 0 1.052.331 1.265.844s.096 1.1-.297 1.492l-5.485 5.485h4.547c1.08 0 1.956.875 1.956 1.955zm21.997-6.11v6.11a1.955 1.955 0 0 1-1.955-1.955v-4.155c0-1.025-.833-1.858-1.858-1.858s-1.857.833-1.857 1.858v6.11a1.955 1.955 0 0 1-1.956-1.955v-4.155c0-1.025-.833-1.858-1.857-1.858s-1.858.833-1.858 1.858v4.155c0 1.08-.875 1.955-1.955 1.955v-6.11a3.817 3.817 0 0 1 3.813-3.813c1.124 0 2.137.49 2.835 1.266a3.8 3.8 0 0 1 2.835-1.266 3.817 3.817 0 0 1 3.813 3.813"
    })
  }));
};
LogoZoomIcon.displayName = 'LogoZoomIcon';